export default __webpack_public_path__ + "static/media/maintance.9b7e6c43.png";